let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("1Qnbg"), load("kZ0xy")]).then(() => parcelRequire('5riP2'));